<template>
  <md-card>
    <h5 class="text-left">
      <strong>
        {{
        editMode ? "Editar" : "Solicitar"
        }}
        Anticipo
      </strong>
    </h5>

    <div class="advance-form">
      <form
        class="md-layout md-alignment-center-space-between"
        id="payload_form"
        @submit.prevent="submit"
      >
        <div class="md-layout-item md-small-size-100 md-size-40">
          <div class="outlined-field">
            <md-field :class="validationClass('amount')">
              <label>Cantidad</label>
              <span class="md-prefix">$</span>
              <md-input
                data-vv-name="amount"
                v-validate="modelValidations.amount"
                v-model="payload.amount"
                :disabled="(!editable || editMode) && !$isAdmin"
              />
            </md-field>
          </div>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-55">
          <div class="outlined-field">
            <md-field :class="validationClass('comment')">
              <label>Comentario</label>
              <md-input
                data-vv-name="comment"
                v-model="payload.comment"
                v-validate="modelValidations.comment"
                :disabled="(!editable || editMode) && !$isAdmin"
              ></md-input>
            </md-field>
          </div>
        </div>
      </form>

      <form ref="form" class="form-buttons">
        <md-button
          :disable="loading"
          class="md-dense"
          :class="[!!pdf ? 'md-success' : '']"
          @click="$refs.pdfFile.click()"
        >
          <md-icon style="margin-right: 8px">picture_as_pdf</md-icon>
          <span style="font-size: 10px">{{ !!pdf ? pdf : "Cargar PDF" }}</span>
        </md-button>
        <input type="file" style="display: none" ref="pdfFile" @input="onPDFChange($event)" />

        <div class="md-layout-item md-small-size-0 md-size-5"></div>

        <md-button
          :disable="loading"
          class="md-dense"
          :class="[!!xml ? 'md-success' : '']"
          @click="$refs.xmlFile.click()"
        >
          <md-icon style="margin-right: 8px">add_to_photos</md-icon>
          <span style="font-size: 10px">{{ !!xml ? xml : "Cargar XML" }}</span>
        </md-button>
        <input type="file" style="display: none" ref="xmlFile" @change="onXMLChange($event)" />
      </form>
    </div>

    <div class="md-layout md-alignment-center-right">
      <md-button :disable="loading" type="submit" form="payload_form" class="md-success md-dense">
        {{
        editMode ? "Editar" : "Solicitar"
        }}
      </md-button>
      <md-button :disable="loading" @click="cancelUpdate" class="md-danger md-dense">Cancelar</md-button>
    </div>
  </md-card>
</template>

<script>
import providesValidator from "@/mixins/providesValidator";

const modelValidations = {
  pdf: {
    required: false,
  },
  xml: {
    required: false,
  },
  amount: {
    regex: /^-?\d*(\.\d+)?$/,
    required: true,
  },
  comment: {
    required: true,
  },
};

export default {
  mixins: [providesValidator],
  props: {
    source: {
      required: false,
    },
    toEditItem: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      payload: {},
      modelValidations,
      pdf: null,
      xml: null,
    };
  },
  computed: {
    editMode() {
      return !!Object.keys(this.toEditItem).length;
    },
    editable() {
      return !!Object.keys(this.toEditItem).length
        ? this.toEditItem.advanceType === "Capturado"
        : true;
    },
  },
  methods: {
    onPDFChange(e) {
      const files = e.target.files;
      const ext = files[0].name.split(".").pop();
      if (ext === "pdf") {
        this.payload.pdf = files[0];
        this.pdf = files[0].name;
      } else {
        this.$notify({
          message: "Formato de archivo incorrecto",
          icon: "close",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
    onXMLChange(e) {
      const files = e.target.files;
      const ext = files[0] && files[0].name.split(".").pop();
      if (ext === "xml") {
        this.payload.xml = files[0];
        this.xml = files[0].name;
      } else {
        this.$notify({
          message: "Formato de archivo incorrecto",
          icon: "close",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
    submit() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.$notify({
            message: "Llena todos los campos <strong>CORRECTAMENTE</strong>",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }
        // if (
        //   Object.keys(this.toEditItem).length &&
        //   this.modify &&
        //   (!this.pdf || !this.xml)
        // ) {
        //   this.$notify({
        //     message:
        //       "Solo se pueden editar los archivos PDF y XML en la edición",
        //     icon: "close",
        //     horizontalAlign: "center",
        //     verticalAlign: "top",
        //     type: "danger",
        //   });
        //   return;
        // } else
        if (this.editMode) {
          this.$emit("updateAdvance", { ...this.payload });
        } else {
          this.$emit(
            "sendAdvance",
            { ...this.payload, advance_type: "requested" },
            this.source.id
          );
        }
      });
    },
    cancelUpdate() {
      this.payload = {};
      this.pdf = null;
      this.xml = null;
      this.$emit("cancelUpdate");
    },
  },
  watch: {
    toEditItem: {
      handler(newVal) {
        this.$refs.form.reset();
        if (Object.keys(newVal).length) {
          this.payload = { ...newVal };
          this.payload.pdf = null;
          this.payload.xml = null;
          this.pdf = newVal.pdf && newVal.pdf.split("/").pop();
          this.xml = newVal.xml && newVal.xml.split("/").pop();
        } else {
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.advance-form {
  display: flex;
  align-items: center;
  justify-content: center;
  form {
    width: 100%;
    padding: 0 12px;
  }
  .form-buttons {
    width: unset;
    display: flex;
    button {
      border-radius: 12px;
    }
  }
}
.edit {
  background-color: #652b9b !important;
  color: white;
}
.create {
  background-color: #1b6e9e !important;
  color: white;
}
.md-card {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/AddAdvances.vue